<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import empresa_sistema from '@/src/services/empresa_sistema'
import billing from '@/src/services/billing'
import formEmpresa from '@/src/components/form-empresa-sistema'

export default {
  components: {
    Layout,
    Loading,
    formEmpresa,
  },
  data() {
    return {
      empresaEdit: {},
      empresa_sistema: [],
      empresaForm: true,
      idUserDelete: '',
      modal: false,
      isLoading: true,
      filter: '',
      filtroTipoContrato: '',
      artPrimaria: '',
      nReceitasArt: '',
      artImpressao: '',
      abaStatus: 'ativas', // 'ativas' | 'inativas'
      empresaFields: [
        {
          key: 'nome',
          label: 'Nome',
        },
        {
          key: 'email',
          label: 'E-mail',
        },
        {
          key: 'tipo_contrato',
          label: 'Contrato',
        },
        {
          key: 'responsavel',
          label: 'Responsável',
        },
        { key: 'actions', label: '' },
      ],
      currentPage: 1,
      perPage: 15,
    }
  },
  computed: {
    rows() {
      return this.empresa_sistema.length
    },
  },
  watch: {
    empresaForm() {
      if (this.empresaForm) {
        this.listandoByFilter()
      }
    },
  },
  mounted() {
    this.listandoByFilter()
    this.$root.$on('back', () => {
      this.empresaForm = true
      this.empresaEdit = {}
    })
  },
  methods: {
    changeAba(status) {
      if (this.abaStatus === status) return
      this.abaStatus = status
      this.currentPage = 1
      this.listandoByFilter()
    },

    listandoByFilter() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true

      const filtros = {
        cnpj: this.filter || undefined,
        tipo_contrato: this.filtroTipoContrato || undefined,
        ativo: this.abaStatus === 'ativas' ? 1 : 0,
      }

      empresa_sistema
        .findByName(token, filtros)
        .then((resposta) => {
          this.empresa_sistema = resposta.data
          this.isLoading = false
        })
        .catch(() => {
          this.empresa_sistema = []
          this.isLoading = false
        })
    },

    abrirForm() {
      if (this.empresaForm === true) {
        this.empresaForm = false
      } else {
        this.empresaForm = true
        this.empresaEdit = {}
      }
    },

    editRegister(empresa) {
      this.empresaEdit = empresa
      this.empresaForm = false
    },

    modalDelete(item) {
      this.modal = true
      this.idUserDelete = item
    },

    handleDelete() {
      const token = this.$store.state.auth.currentUser.token
      const acaoTexto = this.abaStatus === 'ativas' ? 'inativada' : 'ativada'

      empresa_sistema
        .deleteEmpresa(token, this.idUserDelete)
        .then(() => {
          this.listandoByFilter()
          this.$bvToast.toast(`Empresa ${acaoTexto} com sucesso!`, {
            variant: 'success',
            solid: true,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
        .catch(() => {
          this.$bvToast.toast(
            'Ocorreu um erro ao atualizar o status da empresa. Verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.idUserDelete = null
      this.modal = false
    },

    async gerarCobranca(empresa) {
      const token = this.$store.state.auth.currentUser.token

      const confirma = window.confirm(
        `Gerar cobrança para a empresa "${empresa.nome}" e enviar por e-mail?`
      )
      if (!confirma) return

      try {
        this.isLoading = true

        // Chamada correta para o service de billing
        await billing.gerarCobranca(token, empresa.id_empresa_sistema)

        this.$bvToast.toast(
          'Cobrança gerada e documentos enviados por e-mail com sucesso.',
          {
            variant: 'success',
            solid: true,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      } catch (e) {
        console.error(e)
        this.$bvToast.toast(
          'Erro ao gerar cobrança. Verifique os dados da empresa e tente novamente.',
          {
            variant: 'danger',
            solid: true,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      } finally {
        this.isLoading = false
      }
    }
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div>
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Empresas</div>
            <div class="subTitulo">
              Visualize, edite e cadastre novas Empresas na plataforma.
            </div>
          </div>
          <div class="col-md-1">
            <div class="float-right">
              <button class="btn btn-primary" @click="abrirForm">
                <span v-if="empresaForm">Novo</span>
                <span v-else>Ver todos</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Linha separadora -->
        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>

        <!-- Abas Ativas / Inativas -->
        <div v-if="empresaForm" class="row mb-3">
          <div class="col-md-12">
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a href="#" class="nav-link" :class="{ active: abaStatus === 'ativas' }"
                  @click.prevent="changeAba('ativas')">
                  Empresas ativas
                </a>
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link" :class="{ active: abaStatus === 'inativas' }"
                  @click.prevent="changeAba('inativas')">
                  Empresas inativas
                </a>
              </li>
            </ul>
          </div>
        </div>

        <!-- Filtros -->
        <div v-if="empresaForm" class="row">
          <div class="col-md-4">
            <b-form-group id="input-group-1" label="CNPJ" label-for="filter">
              <b-form-input id="filter" v-model="filter" type="text" />
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group id="input-group-2" label="Tipo de Contrato" label-for="tipo-contrato">
              <b-form-select id="tipo-contrato" v-model="filtroTipoContrato" :options="[
                { value: '', text: 'Todos' },
                { value: 'mensal', text: 'Mensal' },
                { value: 'anual', text: 'Anual' },
                { value: 'creditos', text: 'Créditos' }
              ]" />
            </b-form-group>
          </div>
          <div class="col-md-2 mt-4 pt-1">
            <button class="btn btn-primary" @click="listandoByFilter">
              Pesquisar
            </button>
          </div>
        </div>
      </div>

      <div>
        <div v-if="empresaForm">
          <div class="row">
            <div class="col-md-12">
              <div class="float-right">
                <div class="description found">
                  <b>Total de Registros: {{ rows }}</b>
                </div>
              </div>
            </div>
          </div>

          <b-table striped hover responsive="sm" borderless bordered outlined small :items="empresa_sistema"
            :fields="empresaFields" :current-page="currentPage" :per-page="perPage">
            <template #cell(nome)="row">
              <div>
                <strong>{{ row.item.nome }}</strong><br />
                <small>CNPJ: {{ row.item.cnpj }}</small><br />
                <small>
                  {{ row.item.municipio ? row.item.municipio.nome : '-' }}-
                  {{ row.item.estado ? row.item.estado.sigla : '-' }}
                </small>
              </div>
            </template>

            <template #cell(email)="row">
              <div style="display: flex; flex-direction: column; gap: 5px">
                <span>{{ row.item.email || 'E-mail não informado' }}</span>

                <template v-if="row.item.telefone">
                  <a :href="`https://wa.me/55${row.item.telefone.replace(/\D/g, '')}`" target="_blank"
                    title="Conversar no WhatsApp" style="
                      text-decoration: none;
                      color: #25d366;
                      display: flex;
                      align-items: center;
                      gap: 5px;
                    ">
                    <i class="uil uil-whatsapp"></i>
                    {{ row.item.telefone }}
                  </a>
                </template>
                <template v-else>
                  <span>Telefone não informado</span>
                </template>
              </div>
            </template>

            <template #cell(actions)="row">
              <div class="btn-group mb-2">
                <b-dropdown v-b-tooltip.hover size="md" variant="link" toggle-class="text-decoration-none" no-caret
                  :title="abaStatus === 'ativas'
                      ? 'Ações da empresa'
                      : 'Ações da empresa inativa'
                    ">
                  <template #button-content>
                    <i class="uil uil-ellipsis-v"></i>
                  </template>

                  <b-dropdown-item @click="editRegister(row.item)">
                    Editar
                  </b-dropdown-item>

                  <!-- Gerar cobrança só faz sentido para empresas ativas -->
                  <b-dropdown-item v-if="abaStatus === 'ativas'" @click="gerarCobranca(row.item)">
                    Gerar cobrança
                  </b-dropdown-item>

                  <b-dropdown-item @click="modalDelete(row.item.id_empresa_sistema)">
                    {{ abaStatus === 'ativas' ? 'Inativar' : 'Ativar' }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </template>
          </b-table>

          <b-pagination v-model="currentPage" size="md" :total-rows="rows" :per-page="perPage" />
        </div>

        <div v-else>
          <formEmpresa :empresa="empresaEdit" />
        </div>
      </div>

      <div class="borda"></div>
    </div>

    <b-modal v-model="modal" title="Aviso" title-class="font-18">
      <p>
        Tem certeza que deseja
        {{ abaStatus === 'ativas' ? 'inativar' : 'ativar' }}
        esta empresa?
      </p>
      <template #modal-footer>
        <b-button variant="light" @click="modal = false">Não</b-button>
        <b-button variant="danger" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>

    <loading :active.sync="isLoading" color="#008e75" :can-cancel="true" />
  </Layout>
</template>

<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;

  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .subTitulo {
    margin-bottom: 10px;
  }

  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }

  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;

    &.botaoTopo {
      float: right;
    }
  }

  .filterButton {
    background-color: #008e74c7;
    padding: 0 20px;
  }

  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
